import React from 'react';
import { isMenuCollapsed } from '../../../apollo/cache';

const NavigationMenuCollapse = () => (
  <button
    id='navigationMenuCollapseContainer'
    className='back-button'
    onClick={() => isMenuCollapsed(true)}
    aria-label='Close Menu'>
    <svg width='26' height='29' viewBox='0 0 26 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M-7.21238e-07 14.5L25.5 0.21058L25.5 28.7894L-7.21238e-07 14.5Z' fill='white' />
    </svg>
  </button>
);

export default NavigationMenuCollapse;
